import { AnalysisVirtualizedStepProps } from "@models/platform-analysis/entities/analysis";
import { RenderAnalysisSummaryItemProps } from "@models/platform-analysis/entities/steps/summary";
import { FeeCalculatorPortfolioLevel } from "@models/platform-analysis/enums/fee/portfolioLevel";
import { AnalysisStep } from "@models/platform-analysis/enums/step";
import { AnalysisVirtualizedTableStepConfigs } from "@pages/platform-analysis-v2/_id/configs";
import { RootState } from "@redux/store";
import { memo, useEffect } from "react";
import { FeeSMAPortfolioSection } from "../../../fee/analysis/components/fee-sma-portfolio-section";
import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";
import { AnalysisSummaryDTO } from "@models/platform-analysis/entities/steps/summary";
import { isEqual } from "lodash";
import { FeesPerformanceScope } from "@models/platform-analysis/enums/fee/feesPerformanceScope";
import { DELAY_TIME } from "@constants";

export const SummarySmaPortfolioFees = memo(
  ({
    portfolioLevel,
    disabled: sectionDisabled,
  }: RenderAnalysisSummaryItemProps) => {
    const tableVirtualizeConfigs: AnalysisVirtualizedStepProps | undefined =
      AnalysisVirtualizedTableStepConfigs[AnalysisStep.Fee];

    const { setValue } = useFormContext<AnalysisSummaryDTO>();

    const storedPerformanceScope = useSelector(
      (state: RootState) =>
        state.platformAnalysis?.internal?.feeAnalysis?.performanceScope,
    );
    const storedDisplayMode = useSelector(
      (state: RootState) =>
        state.platformAnalysis?.internal?.feeAnalysis?.displayMode,
    );
    const storedDisplayStyle = useSelector(
      (state: RootState) =>
        state.platformAnalysis?.internal?.feeAnalysis?.displayStyle,
    );

    useEffect(() => {
      const handler = setTimeout(() => {
        setValue(
          "excludePerformanceInSMATable",
          isEqual(storedPerformanceScope, FeesPerformanceScope.Excluding),
          { shouldDirty: true },
        );
      }, DELAY_TIME);

      return () => {
        clearTimeout(handler);
      };
    }, [storedPerformanceScope, setValue]);

    useEffect(() => {
      const handler = setTimeout(() => {
        setValue("smaTableViewMode", storedDisplayMode, {
          shouldDirty: true,
        });
      }, DELAY_TIME);

      return () => {
        clearTimeout(handler);
      };
    }, [storedDisplayMode, setValue]);

    useEffect(() => {
      const handler = setTimeout(() => {
        setValue("feesDisplayStyle", storedDisplayStyle, { shouldDirty: true });
      }, DELAY_TIME);

      return () => {
        clearTimeout(handler);
      };
    }, [storedDisplayStyle, setValue]);

    if (!tableVirtualizeConfigs) return <></>;
    if (
      portfolioLevel !== FeeCalculatorPortfolioLevel.Family ||
      !tableVirtualizeConfigs
    ) {
      return <></>;
    }

    return (
      <FeeSMAPortfolioSection
        disabled={sectionDisabled}
        virtualizeProps={{
          ...tableVirtualizeConfigs,
          getSelectedSubProductsFunc: (state: RootState) =>
            state.platformAnalysis?.platformAnalysis?.summary?.smaPortfolioFee
              ?.selectedSubProducts,
          getProductRecommendationDataFunc: (state: RootState) =>
            state.platformAnalysis?.internal?.summary?.productRecommendations,
        }}
      />
    );
  },
);
